import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin, Youtube, ArrowRight } from 'lucide-react';
import { CONTACT, SOCIALS, CATEGORIES } from '../mock';
import { brandIcon } from './BrandIcons';
import Reveal from './Reveal';
import logoFull from '../assets/logo_full.webp';

const socialLucide = { instagram: Instagram, facebook: Facebook, linkedin: Linkedin, youtube: Youtube };

const Footer = () => {
  return (
    <footer className="bg-[#0b0b0b] text-[#cfc7b8] relative overflow-hidden">
      <div className="gold-line" />
      {/* Newsletter */}
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 pt-16 pb-12">
        <Reveal y={40}>
        <div className="grid lg:grid-cols-2 gap-10 items-center border-b border-white/10 pb-14 mb-14">
          <div>
            <p className="overline text-gold-gradient mb-3">Join The Inner Circle</p>
            <h3 className="font-display text-4xl sm:text-5xl text-[#f7f3ec] leading-tight">Be first to know about<br /> new drops &amp; offers.</h3>
          </div>
          <form onSubmit={(e) => e.preventDefault()} className="flex items-center border-b border-[#c6a15b]/40 pb-3 max-w-md lg:ml-auto w-full">
            <input type="email" required placeholder="Enter your email address"
              className="flex-1 bg-transparent outline-none text-[#f7f3ec] placeholder:text-[#7a7365] font-body py-2" />
            <button className="text-[#e7d3a1] hover:translate-x-1 transition-transform" aria-label="Subscribe"><ArrowRight size={22} /></button>
          </form>
        </div>
        </Reveal>

        <Reveal y={40} delay={0.12}>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <img src={logoFull} alt="Nikki's Next Level Hair and Beauty" className="w-40 sm:w-48 h-auto object-contain mb-5" />
            <p className="font-body text-sm leading-relaxed text-[#9c9587] max-w-xs">Premium wigs, braiding hair &amp; luxury bundles — crafted for the woman who refuses to blend in.</p>
          </div>
          <div>
            <h4 className="overline text-[#e7d3a1] mb-5">Shop</h4>
            <ul className="space-y-3 font-body text-sm">
              <li><Link to="/shop" className="hover:text-[#e7d3a1] transition-colors">All Products</Link></li>
              {CATEGORIES.map((c) => (
                <li key={c.slug}><Link to={`/shop/${c.slug}`} className="hover:text-[#e7d3a1] transition-colors">{c.name}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="overline text-[#e7d3a1] mb-5">Company</h4>
            <ul className="space-y-3 font-body text-sm">
              <li><Link to="/about" className="hover:text-[#e7d3a1] transition-colors">Our Story</Link></li>
              <li><Link to="/contact" className="hover:text-[#e7d3a1] transition-colors">Contact</Link></li>
              <li><Link to="/shop" className="hover:text-[#e7d3a1] transition-colors">Bestsellers</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="overline text-[#e7d3a1] mb-5">Get In Touch</h4>
            <ul className="space-y-3 font-body text-sm">
              <li className="flex items-start gap-2"><Phone size={15} className="mt-0.5 text-[#c6a15b]" /> {CONTACT.phonePrimary}</li>
              <li className="flex items-start gap-2"><Phone size={15} className="mt-0.5 text-[#c6a15b]" /> {CONTACT.phoneSecondary}</li>
              <li className="flex items-start gap-2"><Mail size={15} className="mt-0.5 text-[#c6a15b]" /> <span className="break-all">{CONTACT.email}</span></li>
              <li className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 text-[#c6a15b]" /> {CONTACT.address}</li>
            </ul>
            <div className="flex items-center gap-4 mt-6 text-[#c6a15b]">
              {SOCIALS.map((s) => {
                const L = socialLucide[s.icon];
                return (
                  <a key={s.name} href={s.url} aria-label={s.name} target="_blank" rel="noopener noreferrer"
                    className="text-[#c6a15b] hover:text-[#e7d3a1] transition-colors">{L ? <L size={18} /> : brandIcon(s.icon, { width: 18, height: 18 })}</a>
                );
              })}
            </div>
          </div>
        </div>
        </Reveal>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-[#7a7365]">© {new Date().getFullYear()} Nikki’s Next Level. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="font-body text-xs text-[#9c9587] hover:text-[#e7d3a1] transition-colors">Privacy Policy</Link>
            <span className="w-px h-3 bg-white/15" />
            <Link to="/terms" className="font-body text-xs text-[#9c9587] hover:text-[#e7d3a1] transition-colors">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
